import { Reward } from '@shared/models/wallet.model';

export class Ranking {
  userId: string;
  nickName: string;
  rankingPosition: number;
  rankingScore: number;
  prize: Reward;
}
